import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import Search from './Search';
import List from './List';

function Tape({}) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="mb-33">
        <Search />
      </div>
      <div>
        <div className="flex mb-14 items-center">
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('allAdmins')}</span>
          </Button>
          ,
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('admin')}</span>
          </Button>
          , или
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('user')}</span>
          </Button>
          ,<div className="w-1 h-24 mr-27 ml-27 bg-darkGray"></div>
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('openedTheBox')}</span>
          </Button>
          ,
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('closedTheBox')}</span>
          </Button>
          ,
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('changeOfTenant')}</span>
          </Button>
          ,
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">
             {t('changeOfLeaseTerm')}
            </span>
          </Button>
          ,
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('changingTheLock')}</span>
          </Button>
        </div>
        <div className="flex mb-24 items-center">
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">
              {t('paymentTermIsSuitable')}
            </span>
          </Button>
          или
          <Button
            className="p-0 mr-3 ml-3 text-primary flex items-center"
            type="link"
          >
            <span className="border-b-1 border-dotted">{t('paymentIsOverdue')}</span>
          </Button>
        </div>
      </div>
      <List />
    </div>
  );
}

Tape.propTypes = {};

export default Tape;
